import { useState } from 'react';

interface Service {
  icon: string;
  title: string;
  description: string;
  gradient: string;
}

export default function Services() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const services: Service[] = [
    {
      icon: 'ri-search-line',
      title: 'Search Engine Optimization (SEO)',
      description: 'Improve your rankings, drive organic traffic, and increase online visibility with proven SEO strategies that deliver measurable results.',
      gradient: 'from-[#FF6B35] to-[#FF8C61]'
    },
    {
      icon: 'ri-share-line',
      title: 'Social Media Marketing Plans',
      description: 'Strategic, custom plans designed to grow and engage your audience across all major platforms with content that converts.',
      gradient: 'from-[#FF6B35] to-[#FFA07A]'
    },
    {
      icon: 'ri-advertisement-line',
      title: 'Paid Advertising',
      description: 'Google Ads and Meta (Facebook & Instagram) campaigns focused on conversions, ROI, and scaling your business profitably.',
      gradient: 'from-[#FF6B35] to-[#FF7F50]'
    },
    {
      icon: 'ri-layout-line',
      title: 'Website Design & Development',
      description: 'Conversion-focused websites and landing pages built to support your marketing efforts and turn visitors into customers.',
      gradient: 'from-[#FF6B35] to-[#FF9966]'
    },
    {
      icon: 'ri-user-add-line',
      title: 'Lead Generation',
      description: 'Proven systems to attract, capture, and convert high-quality leads that are ready to buy from your business.',
      gradient: 'from-[#FF6B35] to-[#FFB380]'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Strategy & Consulting',
      description: 'Comprehensive marketing strategies tailored to your business goals, backed by data and industry expertise.',
      gradient: 'from-[#FF6B35] to-[#FF8C69]'
    }
  ];

  return (
    <section id="services" className="py-24 bg-[#F8F7F5]">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="mb-16">
          <p className="text-[#FF6B35] text-sm font-semibold tracking-[0.2em] uppercase mb-4">
            WHAT WE DO
          </p>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900">
            Services That Scale Your Business
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl p-12 transition-all duration-300 cursor-pointer ${
                hoveredIndex === index ? 'transform -translate-y-2 shadow-2xl' : 'shadow-md'
              }`}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className={`w-20 h-20 rounded-full bg-gradient-to-br ${service.gradient} flex items-center justify-center mb-8`}>
                <i className={`${service.icon} text-white text-4xl`}></i>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-5">
                {service.title}
              </h3>

              <p className="text-gray-600 text-base leading-relaxed mb-8">
                {service.description}
              </p>

              <a
                href="#contact"
                className="text-[#FF6B35] font-medium inline-flex items-center gap-2 hover:gap-3 transition-all cursor-pointer"
              >
                Learn More
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
